import React from 'react';
const IconArrowLineRight = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M10.1798 12L5.58984 7.41L6.99984 6L12.9998 12L6.99984 18L5.58984 16.59L10.1798 12ZM17.9998 6H15.9998V18H17.9998V6Z" fill="#666666"/>
</svg>
);
};
export default IconArrowLineRight;